import React from 'react';
import './Certifications.css';

const Certifications = () => {
    const certifications = [
        {
            title: "AWS Academy Graduate – Cloud Foundations",
            issuer: "Amazon Web Services",
            description: "Acquired comprehensive knowledge of AWS core services including compute, storage, databases, networking, and security. Gained hands-on experience in deploying and managing cloud-based solutions, implementing cost optimization strategies, and ensuring security and compliance in AWS environments."
        },
        {
            title: "AWS Academy Graduate – Cloud Web Application Builder",
            issuer: "Amazon Web Services",
            description: "Gained expertise in designing, developing, and deploying scalable web applications using AWS services. Learned to integrate cloud-native solutions, leveraging AWS Lambda, API Gateway, DynamoDB, and other services while following AWS best practices for secure and efficient application development."
        }
    ];

    return (
        <section id="certifications" className="section">
            <div className="certifications-container">
                <div className="certifications-heading-wrapper">
                    <h2>Certifications</h2>
                </div>
                <div className="certifications-content">
                    {certifications.map((cert, index) => (
                        <div key={index} className="certification-item">
                            <div className="certification-header">
                                <h3>{cert.title}</h3>
                            </div>
                            <div className="certification-issuer-wrapper">
                                <span className="certification-issuer">{cert.issuer}</span>
                            </div>
                            <p className="certification-description">{cert.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Certifications;
